import clsx from 'clsx'
import { useRef, useState } from 'react'
import { getRawMessage } from '../../../locale'
import Radio from './Radio'
import { makeStyles } from '@mui/styles'
import { isRtl } from '../../../settings/locale.settings'
import { Observer } from 'mobx-react'
import formState from 'components/Pages/FormMaker/formState'

const useStyles = makeStyles((theme) => ({
  otherOption: {
    display: 'flex',
    alignItems: 'center',

    '& .formz-radio-input-label-text': {
      flip: isRtl,
      marginRight: `${theme.spacing(1)} !important`,
    },
  },
}))
function OtherOptionInput({ onChange, name, selectedValue, uniqueName }) {
  const inputRef = useRef(null)
  const [inputValue, setInputValue] = useState('')
  const classes = useStyles()

  const focusInput = () => {
    inputRef.current.focus()
    onChange(inputValue)
  }
  const onInputChange = (value) => {
    setInputValue(value)
    onChange(value)
  }
  const isOtherChoiceSelected = () =>
    Boolean(selectedValue === inputValue && inputValue)

  return (
    <Observer>
      {() => {
        const label =
          formState
            .$('theme_config')
            .$('customized_texts')
            .$('other_choice_label').value || getRawMessage('general.other')
        return (
          <div
            className={clsx({
              [classes.otherOption]: true,
              'choice-other-option': true,
            })}
          >
            <Radio
              type="radio"
              value={uniqueName}
              name={label}
              onCheck={focusInput}
              checked={isOtherChoiceSelected()}
            />
            <input
              className="choice-other-option-input"
              value={inputValue}
              ref={inputRef}
              type="text"
              name={name}
              onChange={(event) => onInputChange(event.target.value)}
            />
          </div>
        )
      }}
    </Observer>
  )
}

export default OtherOptionInput
